import React, { useState } from 'react';
import {
    Route as ReactRouterRoute,
    Routes as ReactRouterRoutes,
} from 'react-router-dom';
import { Route } from '../../../../types';
import { DFab, DPage, DPageBody } from '../../../dum';
import { SUpsertOrderAdjustmentDialog } from '../../../smart';
import { ORDER_ADJUSTMENT_TYPE_DEVOLUCION_ID } from '../../../smart/forms/upsert/production/order-adjustment/order-adjustment-form';
import { OrderAdjustmentsListBlock } from '../../production/order-adjustments-home/order-adjustments/blocks/order-adjustments-block';

// Devoluciones (Ventas domain). A devolución is just an order adjustment of the
// "Devolucion" type, so this page reuses the order-adjustment list + form,
// pinning the type to Devolucion: the list is prefiltered to it and the create
// form preseeds and locks it. See the Devoluciones plan.
const returnsPages: Route[] = [
    {
        name: 'ReturnsPage',
        path: '/',
        component: (
            <DPage animated>
                <DPageBody disableGutters>
                    <OrderAdjustmentsListBlock
                        lockedOrderAdjustmentTypeId={
                            ORDER_ADJUSTMENT_TYPE_DEVOLUCION_ID
                        }
                        title={'Devoluciones'}
                        storageKey={'ReturnsPage'}
                    />
                </DPageBody>
            </DPage>
        ),
        title: 'Devoluciones',
        navbar: false,
    },
];

export function ReturnsHomePage() {
    const [open, setOpen] = useState(false);

    return (
        <DPage>
            <DFab
                onClick={() => {
                    setOpen(true);
                }}
            />
            <ReactRouterRoutes>
                {returnsPages.map((page, index) => {
                    return (
                        <ReactRouterRoute
                            path={page.path}
                            element={page.component}
                            key={index}
                        />
                    );
                })}
            </ReactRouterRoutes>
            <SUpsertOrderAdjustmentDialog
                open={open}
                setOpen={setOpen}
                lockedOrderAdjustmentTypeId={ORDER_ADJUSTMENT_TYPE_DEVOLUCION_ID}
            />
        </DPage>
    );
}
